import { STACKED_BAR_GAP } from '@shopify/polaris-viz-core';

function pushGapToArray({
  gaps,
  index,
  direction,
  firstGapValue
}) {
  if (!gaps[direction][gaps[direction].length - 1]) {
    gaps[direction].push({
      index,
      gap: firstGapValue
    });
    return;
  }

  const {
    gap
  } = gaps[direction][gaps[direction].length - 1];
  gaps[direction].push({
    index,
    gap: gap + STACKED_BAR_GAP
  });
}

export { pushGapToArray };
